import { render, staticRenderFns } from "./AccountantDashboard.vue?vue&type=template&id=0653f4ae&scoped=true&"
import script from "./AccountantDashboard.vue?vue&type=script&lang=js&"
export * from "./AccountantDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AccountantDashboard.vue?vue&type=style&index=0&id=0653f4ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0653f4ae",
  null
  
)

export default component.exports